import { render } from "./BlacklistManagement.vue?vue&type=template&id=762b8e3a&scoped=true"
import script from "./BlacklistManagement.vue?vue&type=script&lang=js"
export * from "./BlacklistManagement.vue?vue&type=script&lang=js"

import "./BlacklistManagement.vue?vue&type=style&index=0&id=762b8e3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762b8e3a"]])

export default __exports__